import { Log, Tracker } from '../Tracker';
import { sendWithPageviewHandling } from '../utils/pageviewHelper';
import { UBLSender } from './types';

export function createPostySender(tracker: Tracker): UBLSender {
  const sender = (log: Log) => sendWithPageviewHandling(log, postySubl);
  return Object.assign(sender, tracker) as UBLSender;
}

function postySubl(log: Log): void {
  if (typeof window !== 'undefined') {
    const app_window = window as any;
    const processed_log = { ...log, client_access_time: Date.now() };
    try {
      if (app_window.posty?.subl) {
        app_window.posty.subl(JSON.stringify(processed_log));
      } else if (app_window.webkit?.messageHandlers?.posty?.postMessage) {
        app_window.webkit.messageHandlers.posty.postMessage({
          name: 'subl',
          parameters: processed_log,
        });
      }
    } catch (error: any) {
      console.error('[subl error]', error.message);
    }
  }
}
